export default "__VITE_ASSET__DDIheT9i__"